// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SuspensionStatus from "../../../../app/suspension/entity/SuspensionStatus.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Event Time"
            },
            accessor: (function (suspension_record) {
                return {
                        TAG: /* Text */0,
                        _0: suspension_record.event_time
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Event Type"
              },
              accessor: (function (suspension_record) {
                  return {
                          TAG: /* Text */0,
                          _0: SuspensionStatus.toString(suspension_record.status)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Event Mode"
                },
                accessor: (function (suspension_record) {
                    return {
                            TAG: /* Text */0,
                            _0: suspension_record.event_mode
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(suspensionInfo) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: suspensionInfo,
              children: (function (suspensionInfo) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: getColumnsSchema(undefined),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(suspensionInfo.suspension_history, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getColumnsSchema ,
  getView ,
  
}
/* react Not a pure module */
